import BaseButton from 'components/atoms/baseButton';
import { useReducer } from 'react';
import LinkChainIcon from 'components/atoms/icons/link-cain';
import LinkedReadingsModal from 'components/molecules/reading-call-audio-player/linked-readings-modal';
import { useTranslation } from 'react-i18next';

import type { ILinkCallReadingsTool } from 'infrastructure/hooks/link-call-readings-tool/types';
import type { FC } from 'react';
import type { Timezones } from 'infrastructure/enums';

interface LinkedReadingsListProps {
  linkedReadings: ILinkCallReadingsTool['linkedReadings'];
  patientThreshold: ILinkCallReadingsTool['patientThreshold'];
  patientTimezone: Timezones;
}

const LinkedReadingsList: FC<LinkedReadingsListProps> = ({
  linkedReadings,
  patientThreshold,
  patientTimezone,
}) => {
  const [open, toggleOpen] = useReducer((v) => !v, false);
  const { t } = useTranslation();

  return (
    <>
      <BaseButton
        label={t('linkedCallReadings.linkedReadings', {
          count: linkedReadings.length ?? 0,
        })}
        icon={<LinkChainIcon />}
        type="secondary"
        onClick={toggleOpen}
        disabled={linkedReadings.length === 0 || open}
      />
      {open && (
        <LinkedReadingsModal
          linkedCallReadings={linkedReadings}
          open={open}
          toggle={toggleOpen}
          thresholds={patientThreshold!}
          patientTimezone={patientTimezone}
        />
      )}
    </>
  );
};
export default LinkedReadingsList;
